// extracted by mini-css-extract-plugin
module.exports = {"container":"Loading_container__8qBsC","center":"Loading_center__38p1U"};